import { __decorate } from "tslib";
/**
 * 签署合同组件
 */
import React, { Component } from 'react';
import { dispatch, getState } from '@@/store';
import { connect } from '@souche-f2e/muji';
import { Modal, Button } from 'antd';
import styles from '../_style/index.less';
import { judgeArr } from '@/shared/functions';
const mapStateToProps = (rootState) => ({
    WaitSign: rootState.waitSign,
});
// @ts-ignore
let SignContract = class SignContract extends Component {
    constructor(props) {
        super(props);
        this.handleCancel = this.handleCancel.bind(this);
        this.handleOk = this.handleOk.bind(this);
    }
    // 在线签订
    handleOk() {
        const { orderId } = getState().waitSign;
        dispatch.waitSign.getQRCode(orderId);
    }
    // 关闭膜态框
    handleCancel() {
        dispatch.waitSign.closeSignModal({});
    }
    // 二维码
    _renderQrCode() {
        const { qrCodeUrl } = this.props.WaitSign;
        return (<div className={styles.ui_qrcode}>
        <img className={styles.ui_qrcode_img} src={qrCodeUrl}/>
      </div>);
    }
    // 合同图片
    _renderContractPic() {
        const { contract } = this.props.WaitSign;
        return (<div className={styles.ui_qrcode}>
        {judgeArr(contract) && contract.map((item, index) => (<img className={styles.ui_contract} src={item} key={index}/>))}
      </div>);
    }
    // 根据二维码显示状态控制膜态框底部显示内容
    getFooter() {
        const { showQrcode } = this.props.WaitSign;
        let footer = [];
        if (!showQrcode) {
            footer = [
                <Button key="submit" type="primary" onClick={this.handleOk}>在线签订</Button>,
                <Button key="back" onClick={this.handleCancel}>关闭</Button>,
            ];
        }
        else {
            footer = [
                <div key="text">请截图并发给买家</div>,
            ];
        }
        return footer;
    }
    render() {
        const { contractVisible, showQrcode } = this.props.WaitSign;
        return (<Modal title={showQrcode ? '请买家扫描完成签订' : '成交确认合同'} visible={contractVisible} onCancel={this.handleCancel} footer={this.getFooter()} width={'700px'}>
        {showQrcode ? this._renderQrCode() : this._renderContractPic()}
      </Modal>);
    }
};
SignContract = __decorate([
    connect(mapStateToProps)
], SignContract);
export default SignContract;
